import { CheckCircle2, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "./Reveal";

export default function Comparison() {
  const { t } = useTranslation();
  const ROWS = t("comparison.rows", { returnObjects: true });

  return (
    <section id="comparativa" data-testid="comparison-section" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <Reveal className="text-center max-w-2xl mx-auto">
        <div className="text-xs uppercase tracking-[0.28em] text-[#F5CB5C] font-semibold">{t("comparison.kicker")}</div>
        <h2 className="mt-4 font-display text-white text-2xl sm:text-3xl lg:text-4xl">
          {t("comparison.title1")} <span className="text-gold-gradient">{t("comparison.titleHighlight")}</span>{t("comparison.titleEnd")}
        </h2>
        <p className="mt-4 text-sm sm:text-base text-gray-400">
          {t("comparison.desc")}
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-12">
        <div data-testid="comparison-table-wrapper" className="overflow-x-auto rounded-3xl glass-card">
          <table className="w-full min-w-[820px] border-collapse text-sm">
            <thead>
              <tr className="text-left">
                <th className="p-5 sm:p-6 text-gray-400 font-medium text-xs uppercase tracking-[0.16em]">{t("comparison.headerAspect")}</th>
                <th
                  data-testid="tech-table-uv-column"
                  className="p-5 sm:p-6 bg-gradient-to-b from-[#540F20] to-[#24020B] border-x-2 border-t-2 border-[#F5CB5C]/50 rounded-t-2xl"
                >
                  <span className="flex items-center gap-2 font-display text-[#F5CB5C] text-sm sm:text-base">
                    <Zap size={16} /> {t("comparison.headerUv")}
                  </span>
                  <span className="block text-[10px] text-gray-400 mt-1 tracking-wide font-sans">{t("comparison.headerUvSub")}</span>
                </th>
                <th className="p-5 sm:p-6 text-gray-300 font-display text-sm sm:text-base">{t("comparison.headerSerigrafia")}</th>
                <th className="p-5 sm:p-6 text-gray-300 font-display text-sm sm:text-base">{t("comparison.headerCo2")}</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={r.aspect} data-testid={`comparison-row-${i}`} className="border-t border-white/5">
                  <td className="p-5 sm:p-6 text-gray-300 font-medium">{r.aspect}</td>
                  <td className={`p-5 sm:p-6 bg-[#24020B]/70 border-x-2 border-[#F5CB5C]/50 text-[#FAE19C] ${i === ROWS.length - 1 ? "border-b-2 rounded-b-2xl" : ""}`}>
                    <span className="flex items-start gap-2">
                      <CheckCircle2 size={15} className="text-[#F5CB5C] mt-0.5 shrink-0" />
                      {r.uv}
                    </span>
                  </td>
                  <td className="p-5 sm:p-6 text-gray-500">{r.serigrafia}</td>
                  <td className="p-5 sm:p-6 text-gray-500">{r.co2}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="lg:hidden text-center text-xs text-gray-600 mt-3">{t("comparison.swipeHint")}</p>
      </Reveal>
    </section>
  );
}
